import { render } from "./SegmentationComplexProperty.vue?vue&type=template&id=00735b28&scoped=true"
import script from "./SegmentationComplexProperty.vue?vue&type=script&lang=ts"
export * from "./SegmentationComplexProperty.vue?vue&type=script&lang=ts"

import "./SegmentationComplexProperty.vue?vue&type=style&index=0&id=00735b28&lang=scss"
import "./SegmentationComplexProperty.vue?vue&type=style&index=1&id=00735b28&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-00735b28"

export default script